
import { Button, useTheme } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import { iconos } from "../../../data";




export const BotonesAndCargando = ({ cargando, titulo, titulo2, icon1, icon2, handleSubmit, type, bloqueado=false }) => {


    const theme = useTheme();
    const colorfd = `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.dark})`;


    if (cargando) {
        return (
        <LoadingButton
            fullWidth
            loading
            loadingPosition="start"
            startIcon={iconos[icon2]}
            variant="contained"
        >
            { titulo2 }
        </LoadingButton>
        );
    }

    return (
        <Button
            fullWidth
            variant="contained"
            sx={{
                // background: colorfd,
                "&.Mui-disabled": {
                backgroundColor: "#bdbdbd",
                color: "#ffffff" 
                }
            }}
            startIcon={iconos[icon1]}
            type={type}
            onClick={type ? undefined : handleSubmit}
            disabled={ bloqueado }
        >
            { titulo }
        </Button>
    );
}
